(function(){
  var WKEY='pl_wishlist_v1';
  var AKEY='pl_stock_alerts_v1';
  var LEGACY_MERGED_KEY='pl_legacy_merged_v1';

  // PATISSLAND R-58 : i18n minimal, meme pattern que le bandeau promo AOUT10 (detection Shopify.locale),
  // couvre les messages generes uniquement en JS (toast, validations du formulaire d'alerte).
  // Les libelles des boutons sont deja traduits cote Liquid via data-attributes.
  // R-60 (25/08) : terminologie "Wishlist" remplacee par "Favoris" (et equivalent par langue) dans
  // les toasts. Cles d'objet (WKEY/AKEY...), classes CSS et evenements pl:wishlist:change inchanges.
  var I18N = {
    fr: { toastAdded:'Ajouté à vos favoris', toastRemoved:'Retiré de vos favoris', invalidEmail:'Merci de renseigner un email valide.', alertSuccess:'C’est noté, on vous prévient dès le retour en stock.', alertDuplicate:'Vous êtes déjà sur la liste pour ce produit.' },
    en: { toastAdded:'Added to your Favourites', toastRemoved:'Removed from your Favourites', invalidEmail:'Please enter a valid email.', alertSuccess:'Got it, we’ll notify you as soon as it’s back in stock.', alertDuplicate:'You’re already on the list for this product.' },
    es: { toastAdded:'Añadido a tus favoritos', toastRemoved:'Eliminado de tus favoritos', invalidEmail:'Introduce un email válido.', alertSuccess:'Anotado, te avisaremos en cuanto vuelva a estar disponible.', alertDuplicate:'Ya estás en la lista para este producto.' },
    it: { toastAdded:'Aggiunto ai tuoi preferiti', toastRemoved:'Rimosso dai tuoi preferiti', invalidEmail:'Inserisci un’email valida.', alertSuccess:'Fatto, ti avviseremo appena torna disponibile.', alertDuplicate:'Sei già in lista per questo prodotto.' },
    de: { toastAdded:'Zu den Favoriten hinzugefügt', toastRemoved:'Von den Favoriten entfernt', invalidEmail:'Bitte geben Sie eine gültige E-Mail-Adresse ein.', alertSuccess:'Notiert, wir benachrichtigen Sie, sobald es wieder verfügbar ist.', alertDuplicate:'Sie stehen für dieses Produkt bereits auf der Liste.' },
    nl: { toastAdded:'Toegevoegd aan je favorieten', toastRemoved:'Verwijderd uit je favorieten', invalidEmail:'Voer een geldig e-mailadres in.', alertSuccess:'Genoteerd, we laten het je weten zodra het weer op voorraad is.', alertDuplicate:'Je staat al op de lijst voor dit product.' }
  };

  function detectLang(){
    var l = '';
    try { if (window.Shopify && Shopify.locale) l = Shopify.locale; } catch(e){}
    if (!l) { l = document.documentElement.getAttribute('lang') || 'fr'; }
    l = l.toLowerCase().slice(0,2);
    return I18N[l] ? l : 'fr';
  }
  var T = I18N[detectLang()];
  var alertMessages = {
    fr: {pending:'Enregistrement…', error:'Votre alerte n’a pas été enregistrée. Veuillez réessayer.', limited:'Trop de demandes. Veuillez réessayer un peu plus tard.'},
    en: {pending:'Saving…', error:'Your alert was not saved. Please try again.', limited:'Too many requests. Please try again later.'},
    es: {pending:'Guardando…', error:'No se ha guardado tu alerta. Inténtalo de nuevo.', limited:'Demasiadas solicitudes. Inténtalo más tarde.'},
    it: {pending:'Salvataggio…', error:'Il tuo avviso non è stato salvato. Riprova.', limited:'Troppe richieste. Riprova più tardi.'},
    de: {pending:'Wird gespeichert…', error:'Ihre Benachrichtigung wurde nicht gespeichert. Bitte versuchen Sie es erneut.', limited:'Zu viele Anfragen. Bitte versuchen Sie es später erneut.'},
    nl: {pending:'Opslaan…', error:'Je melding is niet opgeslagen. Probeer het opnieuw.', limited:'Te veel aanvragen. Probeer het later opnieuw.'}
  }[detectLang()];

  function read(key){
    try{ var v = JSON.parse(localStorage.getItem(key)); return Array.isArray(v) ? v : []; }catch(e){ return []; }
  }
  function write(key, val){
    try{ localStorage.setItem(key, JSON.stringify(val)); }catch(e){}
  }

  var PLW = {
    getAll: function(){ return read(WKEY); },
    has: function(id){ return read(WKEY).some(function(p){ return String(p.id)===String(id); }); },
    count: function(){ return read(WKEY).length; },
    toggle: function(snapshot){
      var list = read(WKEY);
      var idx = -1;
      for(var i=0;i<list.length;i++){ if(String(list[i].id)===String(snapshot.id)){ idx=i; break; } }
      var added;
      if(idx>-1){ list.splice(idx,1); added=false; }
      else { snapshot.addedAt = Date.now(); list.unshift(snapshot); added=true; }
      write(WKEY, list);
      document.dispatchEvent(new CustomEvent('pl:wishlist:change', {detail:{count:list.length}}));
      return added;
    },
    remove: function(id){
      var list = read(WKEY).filter(function(p){ return String(p.id)!==String(id); });
      write(WKEY, list);
      document.dispatchEvent(new CustomEvent('pl:wishlist:change', {detail:{count:list.length}}));
    },
    clear: function(){
      write(WKEY, []);
      document.dispatchEvent(new CustomEvent('pl:wishlist:change', {detail:{count:0}}));
    }
  };

  var PLAlert = {
    add: async function(entry){
      if(!window.PL_ALERT_ENDPOINT) throw new Error('Stock alert endpoint unavailable');
      var controller = new AbortController();
      var timer = setTimeout(function(){ controller.abort(); }, 15000);
      try {
        var response = await fetch(window.PL_ALERT_ENDPOINT, {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify(entry),
          signal: controller.signal
        });
        var result = await response.json().catch(function(){ return null; });
        if(!response.ok || !result || result.ok !== true){
          var error = new Error('Stock alert registration failed');
          error.status = response.status;
          throw error;
        }
        var list = read(AKEY).filter(function(item){
          return !(String(item.productId) === String(entry.productId) && String(item.email).toLowerCase() === entry.email.toLowerCase());
        });
        entry.addedAt = Date.now();
        entry.serverConfirmed = true;
        list.push(entry);
        write(AKEY, list);
        return !result.alreadyRegistered;
      } finally {
        clearTimeout(timer);
      }
    }
  };

  window.PLWishlist = PLW;
  window.PLStockAlert = PLAlert;

  var toastTimer = null;
  function showToast(message){
    var el = document.getElementById('pl-toast');
    if(!el){
      el = document.createElement('div');
      el.id = 'pl-toast';
      el.className = 'pl-toast';
      el.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 20.3s-7.6-4.6-10-9.1A5.4 5.4 0 0 1 12 5.9a5.4 5.4 0 0 1 10 5.3c-2.4 4.5-10 9.1-10 9.1z"/></svg><span></span>';
      document.body.appendChild(el);
    }
    el.querySelector('span').textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ el.classList.remove('is-visible'); }, 2200);
  }

  function matchAddToCartStyle(){
    var atc = document.querySelector('.pl-pdp-actions__item--cart .btn');
    var hearts = document.querySelectorAll('.pl-wishlist-heart--pdp');
    if(!atc || !hearts.length) return;
    var cs = window.getComputedStyle(atc);
    var typoProps = ['fontFamily','fontSize','fontWeight','fontStyle','letterSpacing','textTransform'];
    var bg = cs.backgroundColor;
    var fg = cs.color;
    for(var i=0;i<hearts.length;i++){
      var el = hearts[i];
      for(var j=0;j<typoProps.length;j++){ el.style[typoProps[j]] = cs[typoProps[j]]; }
      el.style.setProperty('--pl-heart-active-bg', bg);
      el.style.setProperty('--pl-heart-active-fg', fg);
      el.style.setProperty('--pl-heart-active-border', bg);
      var label = el.querySelector('.pl-wishlist-heart__label');
      if(label){
        for(var k=0;k<typoProps.length;k++){ label.style[typoProps[k]] = cs[typoProps[k]]; }
      }
    }
  }

  function hydrateLegacy(){
    try{
      var already = localStorage.getItem(LEGACY_MERGED_KEY);
      if(already) return;
      var legacy = window.PL_LEGACY_WISHLIST;
      if(!legacy || !legacy.length){ return; }
      var current = read(WKEY);
      var byId = {};
      current.forEach(function(p){ byId[String(p.id)] = true; });
      legacy.forEach(function(p){
        if(!byId[String(p.id)]){
          current.push(p);
          byId[String(p.id)] = true;
        }
      });
      write(WKEY, current);
      localStorage.setItem(LEGACY_MERGED_KEY, '1');
      document.dispatchEvent(new CustomEvent('pl:wishlist:change', {detail:{count:current.length}}));
    }catch(e){}
  }

  function updateHeartState(el){
    var id = el.getAttribute('data-product-id');
    var active = PLW.has(id);
    el.classList.toggle('is-active', active);
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
    var ariaAdd = el.getAttribute('data-aria-add');
    var ariaRemove = el.getAttribute('data-aria-remove');
    el.setAttribute('aria-label', active ? (ariaRemove || 'Retirer des favoris') : (ariaAdd || 'Ajouter aux favoris'));
    var label = el.querySelector('.pl-wishlist-heart__label');
    if(label){
      var idle = el.getAttribute('data-label-idle');
      var activeLabel = el.getAttribute('data-label-active');
      label.textContent = active ? (activeLabel || label.textContent) : (idle || label.textContent);
    }
  }

  function refreshHearts(){
    var hearts = document.querySelectorAll('[data-pl-wishlist-toggle]');
    for(var i=0;i<hearts.length;i++){ updateHeartState(hearts[i]); }
    var counters = document.querySelectorAll('[data-pl-wishlist-count]');
    var n = PLW.count();
    for(var j=0;j<counters.length;j++){
      counters[j].textContent = n;
      counters[j].classList.toggle('is-visible', n > 0);
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-pl-wishlist-toggle]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var snapshot = {
      id: btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '#',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || '',
      available: btn.getAttribute('data-product-available') === 'true'
    };
    var added = PLW.toggle(snapshot);
    refreshHearts();
    btn.classList.add('is-pulsing');
    setTimeout(function(){ btn.classList.remove('is-pulsing'); }, 260);
    showToast(added ? T.toastAdded : T.toastRemoved);
  });

  document.addEventListener('submit', async function(e){
    var form = e.target.closest('[data-pl-stock-alert-form]');
    if(!form) return;
    e.preventDefault();
    if(form.dataset.submitting === 'true') return;
    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';
    var msgEl = form.querySelector('[data-pl-stock-alert-msg]');
    if(!input || !input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      if(msgEl){ msgEl.textContent = T.invalidEmail; msgEl.classList.add('is-error'); }
      return;
    }
    var submitBtn = form.querySelector('[type="submit"]');
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if(submitBtn) submitBtn.disabled = true;
    if(msgEl){ msgEl.classList.remove('is-error'); msgEl.textContent = alertMessages.pending; }
    try {
      var ok = await PLAlert.add({
        productId: form.getAttribute('data-product-id'),
        handle: form.getAttribute('data-product-handle') || '',
        title: form.getAttribute('data-product-title') || '',
        email: email,
        lang: (document.documentElement.lang || 'fr').toLowerCase().slice(0,2)
      });
      form.classList.add('is-submitted');
      if(msgEl){ msgEl.classList.remove('is-error'); msgEl.textContent = ok ? T.alertSuccess : T.alertDuplicate; }
      input.disabled = true;
    } catch(error) {
      if(submitBtn) submitBtn.disabled = false;
      if(msgEl){ msgEl.classList.add('is-error'); msgEl.textContent = error.status === 429 ? alertMessages.limited : alertMessages.error; }
    } finally {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('pl:wishlist:change', refreshHearts);

  function init(){
    hydrateLegacy();
    refreshHearts();
    matchAddToCartStyle();
    setTimeout(matchAddToCartStyle, 400);
    setTimeout(matchAddToCartStyle, 1200);
    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(matchAddToCartStyle);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
